/* Local URL */
/* export const API_URL = 'http://localhost:3001'; */
// /* Remote URL */
export const API_URL = 'https://portal.ngunatech.co.ke/api';


export function formatDate(dateString) {
  const options = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false // Using 24-hour format
  };

  const formattedDate = new Date(dateString).toLocaleString('en-US', options);

  const [datePart, timePart] = formattedDate.split(', ');
  const [month, day, year] = datePart.split('/');
  const [hour, minute, second] = timePart.split(':');

  const modifiedHour = hour === '24' ? '00' : hour;

  const formattedDateTime = `${year}-${month}-${day} ${modifiedHour}:${minute}:${second}`;

  return formattedDateTime;
}
export function formatDate2(dateString) {
  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');

  const hour = String(date.getHours()).padStart(2, '0');
  const minute = String(date.getMinutes()).padStart(2, '0');
  const second = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}


export const customStyles = {
  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '95%',
    maxWidth: '700px',
    padding: '2rem',
    background: '#fff',
    border: 'none',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    outline: 'none',
    overflow: 'visible',
    transition: 'all 0.3s ease-out'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    transition: 'opacity 0.3s ease-out'
  }
};




export const secret_key = "SMARTAPI2025NGSKEYweGHTSD16934KBJH12"

export const storedData = localStorage?.getItem('_userdata');
export const mapMessage = (message) => {
  const replacements = [
    { pattern: /The code:\d+/, replacement: 'The code:****' },
    { pattern: /PIN for Mobile Banking is:\d+/, replacement: 'PIN for Mobile Banking is:****' },
    { pattern: /Your new pin is \d+/, replacement: 'Your new pin is ****' },
    { pattern: /Your new PIN is \d+/, replacement: 'Your new PIN is ****' },
    { pattern: /your PIN for Mobile Banking is \d+/, replacement: 'your PIN for Mobile Banking is ****' },
    { pattern: /Dear Member, Your PIN for Mobile Banking is \d+/, replacement: 'Dear Member, Your PIN for Mobile Banking is ****' },
    { pattern: /Your\s+pin\s+is\s+\d+/i, replacement: 'Your pin is ****' },
  ];
  
  for (const { pattern, replacement } of replacements) {
    message = message.replace(pattern, replacement);
  }

  return message;
};
